import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'disabled_reasons',
  inputShow: gql`
    query disabledReasons($input: DisabledReasonQueryInput) {
      disabledReasons(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Disabled Reasons',
  },
};
